export default __webpack_public_path__ + "static/media/480_portfolio02-fr-mobile.6afe888a.png";